export default __webpack_public_path__ + "static/screeny-110-gc-2-388660f1dacc7a171470d22bd5790ccd.jpg";